import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { pluck } from '../helpers/utils';

@Pipe({
  name: 'translate'
})
export class AbleraTranslatePipe extends TranslatePipe implements PipeTransform {
  constructor(private _translate: TranslateService, _cd: ChangeDetectorRef) {
    super(_translate, _cd);
  }

  transform(value: any, params?: any): Observable<string> {
    return this._translate.onLangChange.pipe(
      startWith(''),
      map(() => {
        const { key, fallback } = params;
        return value && value[key] ? super.transform(value[key]) : fallback ? pluck(value, fallback) : value ? value : '';
      })
    );
  }
}
